import { keyframes } from '@emotion/react'

import { tokenPrefix } from '@hivewatch/dark'

type ColorScheme = 'dark' | 'light'

// Same pulse the dark Table uses for its loading rows.
const skeletonPulse = keyframes`
  0%, 100% { opacity: 0.35; }
  50%      { opacity: 0.7; }
`

export const darkDevicesPanelStyles = (colorScheme: ColorScheme) => {
  const prefix = tokenPrefix(colorScheme)
  return {
    headerTitle: {
      color: `${prefix}text.primary`,
      textStyle: 'heading',
    },
    header: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '8px',
    },
    checkboxLabel: {
      color: `${prefix}text.secondary`,
      fontFamily: "'Soehne', sans-serif",
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '16px',
    },
    list: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '8px',
    },
    skeletonRow: {
      alignItems: 'center',
      animation: `${skeletonPulse} 1.4s ease-in-out infinite`,
      display: 'flex',
      gap: '10px',
      p: '10px',
      width: '100%',
    },
    skeletonIcon: {
      bg: `${prefix}bg.card-elevated`,
      flexShrink: 0,
      height: '30px',
      width: '30px',
    },
    skeletonLine: {
      bg: `${prefix}bg.card-elevated`,
      height: '14px',
      width: '60%',
    },
    emptyState: {
      alignItems: 'center',
      color: `${prefix}text.secondary`,
      display: 'flex',
      flex: 1,
      fontFamily: "'Soehne', sans-serif",
      fontSize: '14px',
      fontWeight: '500',
      justifyContent: 'center',
      py: '24px',
    },
    trailingIcons: {
      alignItems: 'center',
      display: 'flex',
      gap: '8px',
    },
  }
}
